import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f89f9c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-card" }
const _hoisted_2 = { style: {"margin-top":"3px","display":"flex","padding":"10px"} }
const _hoisted_3 = {
  class: "monospace",
  style: {"display":"flex","flex-direction":"column","flex-grow":"1"}
}
const _hoisted_4 = { style: {"display":"flex","flex-grow":"0","flex-shrink":"1","flex-wrap":"wrap"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Save", -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "h" }

import {
  NPopover, NDivider, FormInst, FormRules,
  NForm, NFormItem, NButton, NTooltip,
  NDatePicker, NSelect, FormItemRule
} from "naive-ui"
import {PencilOutline, TrashCanOutline, InformationOutline, DotsVertical} from "mdue";
import {ValidateError} from "async-validator";
import Modal from "@/components/Modal.vue";
import {QuillEditor} from "@vueup/vue-quill";
import {Schedule, ScheduleDto} from "@/types/Schedule";
import {getCurrentInstance, ref} from "vue";
import axios, {AxiosError} from "axios";
import {useRouter} from "vue-router";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleList',
  props: {
    schedules: null,
    editable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  schedules?: any
  editable?: boolean
}

// Penggunaan Schdeulelist ini didasarkan dari wireframe yang diberikan oleh artspedia
// Dengan asumsi tidak ada rentang waktu yang lebih dari 1 hari
const router = useRouter();

const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message

const form = ref<FormInst[]>([])
const model = ref<Schedule>({} as Schedule)
model.value.description = ''
const modal = ref([])
const currentModal = ref(0)


const typeGroup = props.schedules!.reduce((typeGroup: { [x: string]: any[] }, activity: { type: string; }) => {
  if (!typeGroup[activity.type]) {
    typeGroup[activity.type] = [];
  }
  typeGroup[activity.type].push(activity);
  return typeGroup;
}, {});

const currentModalI = ref(0)

const scheduleGroups = Object.keys(typeGroup).map((type) => {
  return {
    type,
    activity: typeGroup[type]
  }
})
function parseDateTime(date: Date) {
  // const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MEI', 'JUN', 'JUL', 'AGU', 'SEP', 'OKT', 'NOV', 'DES']
  let day = date.getDate().toString()
  if (day.length == 1) {
    day = "0"+day
  }
  return `${day} ${months[date.getMonth()]} ${date.getFullYear()} (${date.toTimeString().substring(0, 5)})`
}

const rules: FormRules = {
  start_time: [{
    required: true,
    type: 'number',
    message: "Start Time is required",
    trigger: ["change"]
  }],
  end_time: [{
    required: true,
    type: 'number',
    validator (rule:FormItemRule, value:Date) {
      if(!value) {
        return new Error('End Time is required')
      } else if(value < model.value.start_time) {
        return new Error('End Time must not be earlier than Start Time')
      }
    },
    trigger: ["change"]
  }],
}

function prepareEditData(activity: any) {
  activity.start_time = new Date(activity.start_time).getTime()
  activity.end_time = new Date(activity.end_time).getTime()
  model.value = activity
}

async function handleSubmit(errors: ValidateError[][] | undefined) {
  if (!errors) {
    let payload = new ScheduleDto(model.value);
    axios.patch("/api/schedule/" + model.value.id.toString(), payload)
        .then(_val => {
          message.success("Schedule is successfully updated!", {showIcon: true, closable: true});
          (modal.value as any)[currentModal.value].showModal = false;
          router.push("/schedule");
        })
        .catch((_err: AxiosError) => {
          message.error("A problem is occurred when updating schedule", {showIcon: true, closable: true});
        })
  }
}

function handleSubmitButtonClick(e: MouseEvent, i: number) {
  e.preventDefault();
  form.value![i].validate(handleSubmit).catch(_error => {
    message.error("Form is invalid", {showIcon: true, closable: true})
  })
}



function hapus(id: number) {
  axios.delete(`/api/schedule/${id}`,
      {headers: {Authorization: `Bearer ${store.state.token}`}}
  )
      .then(response => {
        message.success("Schedule is successfully removed!", {showIcon: true, closable: true})
        // getPortfolio(currentPage.value);
        app!.emit('schedule-delete');
        (modal.value as any)[currentModalI.value].showModal = false;
      })
      .catch((error) => {
        message.error("A problem is occurred when removing schedule. Please try again", {
          showIcon: true,
          closable: true
        })
        console.log(error)
      })
}

function batal(i: number) {
  // console.log(test);
  (modal.value as any)[i].showModal = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scheduleGroups), (schedule) => {
      return (_openBlock(), _createElementBlock("div", {
        key: schedule.id,
        style: {"margin-bottom":"20px"}
      }, [
        _createVNode(_unref(NDivider), { "title-placement": "left" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(schedule.type), 1)
          ]),
          _: 2
        }, 1024),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule.activity, (activity, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: activity.id
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(parseDateTime(new Date(activity.start_time))) + " -", 1),
                _createElementVNode("span", null, _toDisplayString(parseDateTime(new Date(activity.end_time))), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(Modal, {
                  ref_for: true,
                  ref: el => modal.value[i] = el
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_unref(NTooltip), null, {
                      trigger: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "with-icon clear",
                          onClick: () => {currentModalI.value = i}
                        }, [
                          _createVNode(_unref(InformationOutline), { style: {"font-size":"24px"} })
                        ], 8, _hoisted_5)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Info ")
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(activity.type) + " " + _toDisplayString(parseDateTime(new Date(activity.start_time))) + " - " + _toDisplayString(parseDateTime(new Date(activity.end_time))), 1),
                    _createElementVNode("div", {
                      innerHTML: activity.description || '<i>Schedule ini tidak memiliki deskripsi</i>'
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1536),
                _createVNode(Modal, {
                  ref_for: true,
                  ref: el => modal.value[i] = el
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_unref(NTooltip), null, {
                      trigger: _withCtx(() => [
                        _withDirectives(_createElementVNode("button", {
                          class: "with-icon clear",
                          onClick: ($event: any) => (prepareEditData(activity))
                        }, [
                          _createVNode(_unref(PencilOutline), { style: {"font-size":"24px"} })
                        ], 8, _hoisted_7), [
                          [_vShow, __props.editable]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Edit ")
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_unref(NForm), {
                      ref_for: true,
                      ref: el => form.value[i] = el,
                      model: model.value,
                      rules: rules
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NFormItem), {
                          id: "startTimeForm",
                          path: "start_time",
                          label: "Start Time"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDatePicker), {
                              placeholder: "Select Date and Time",
                              value: model.value.start_time,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.value.start_time) = $event)),
                              type: "datetime"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NFormItem), {
                          id: "endTimeForm",
                          path: "end_time",
                          label: "End Time"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDatePicker), {
                              placeholder: "Select Date and Time",
                              value: model.value.end_time,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((model.value.end_time) = $event)),
                              type: "datetime"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NFormItem), {
                          id: "typeForm",
                          path: "type",
                          label: "Tipe Schedule"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NSelect), {
                              value: model.value.type,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((model.value.type) = $event)),
                              disabled: "",
                              size: "large"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        (model.value.type.toLowerCase() === 'appointment')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createTextVNode(" Description "),
                              _createVNode(_unref(QuillEditor), {
                                theme: "snow",
                                "content-type": "html",
                                content: model.value.description,
                                "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((model.value.description) = $event)),
                                placeholder: "Description"
                              }, null, 8, ["content"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(NButton), {
                          id: "submitBtn",
                          type: "primary",
                          "attr-type": "submit",
                          size: "large",
                          onClick: (e) => {currentModal.value = i; handleSubmitButtonClick(e, i)}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["model"])
                  ]),
                  _: 2
                }, 1536),
                _createVNode(Modal, {
                  ref_for: true,
                  ref: el => modal.value[i] = el
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_unref(NTooltip), null, {
                      trigger: _withCtx(() => [
                        _withDirectives(_createElementVNode("button", {
                          class: "hapus with-icon clear",
                          id: "delete",
                          onClick: () => {currentModalI.value = i}
                        }, [
                          _createVNode(_unref(TrashCanOutline), { style: {"font-size":"24px"} })
                        ], 8, _hoisted_10), [
                          [_vShow, __props.editable]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Remove ")
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  content: _withCtx(() => [
                    _createTextVNode(" Are you sure you want to remove this schedule? "),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(NButton), {
                        type: "default",
                        onClick: ($event: any) => (batal(i))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Cancel ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_unref(NButton), {
                        class: "hapus accent",
                        id: "confirm",
                        type: "primary",
                        onClick: ($event: any) => (hapus(activity.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Remove ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1536)
              ])
            ])
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})